import { Box, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { apiGet } from '../api.js';

const StatCard = ({ label, value }) => (
  <Box bg="white" borderWidth="1px" borderColor="gray.200" borderRadius="lg" p={4}>
    <Text fontSize="sm" color="gray.500">{label}</Text>
    <Heading size="lg">{value}</Heading>
  </Box>
);

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await apiGet('/dashboard');
        setData(result);
      } catch (err) {
        setError(err.message || 'Failed to load dashboard');
      }
    };
    fetchData();
  }, []);

  return (
    <Stack spacing={6}>
      <Box>
        <Heading size="lg">Dashboard</Heading>
        <Text color="gray.500">Overview of your business</Text>
      </Box>
      {error && <Text color="red.500">{error}</Text>}
      {data && (
        <>
          <SimpleGrid columns={{ base: 1, md: 4 }} spacing={4}>
            <StatCard label="Total Clients" value={data.totalClients} />
            <StatCard label="Total Articles" value={data.totalArticles} />
            <StatCard label="Active Articles" value={data.activeArticles} />
            <StatCard label="Released Articles" value={data.releasedArticles} />
          </SimpleGrid>
          <Box bg="white" borderWidth="1px" borderColor="gray.200" borderRadius="lg" p={4}>
              <Heading size="md" mb={4}>Recent Articles</Heading>
              {data.recentArticles?.length ? (
                <Stack spacing={3}>
                  {data.recentArticles.map(article => (
                    <Box key={article._id} p={3} border="1px solid" borderColor="gray.200" borderRadius="md">
                      <Text fontWeight="semibold">{article.client?.name || 'N/A'}</Text>
                      <Text fontSize="sm" color="gray.500">
                        {article.nameOrNo || 'N/A'} • ₹{article.amount || 0}
                      </Text>
                    </Box>
                  ))}
                </Stack>
              ) : (
                <Text color="gray.500">No recent articles found.</Text>
              )}
          </Box>
        </>
      )}
    </Stack>
  );
};

export default Dashboard;
